document.addEventListener("DOMContentLoaded", function() {
  // Revelar el menú superior de inmediato al cargar
  const headerGroup = document.getElementById('header-group');
  if (headerGroup) {
    setTimeout(() => {
      headerGroup.classList.add('is-revealed');
    }, 150);
  }

  // Observer para las secciones conforme haces scroll
  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-revealed');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll('.shopify-section:not(#header-group)').forEach(section => {
    observer.observe(section);
  });
});